import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, Typography } from "antd";

import Back from "../../../../assets/icons/LeftBack.svg";
import PromoCodeForm from "../../../../components/promoCode/promoCodeForm";
import { getPromoCodeById } from "../../../../api/user";

const EditPromoCode = () => {
  let { id } = useParams();
  const navigate = useNavigate();

  const [editPromoCode, setEditPromoCode] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id && id !== "new") {
      setLoading(true);
      const fetchData = async () => {
        try {
          const res = await getPromoCodeById(id);
          setEditPromoCode(res);
        } catch (error) {
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [id]);

  return (
    <div>
      <div className="grid gap-x-1 gap-y-1 space-x-2 w-full pr-2">
        <div className="flex pt-3 pl-3 place-content-between">
          <Link to="/main/promo-code">
            <div className="flex items-center">
              <div className="w-4.4 m-auto grid justify-center h-auto py-1 rounded-lg bg-primaryPurple cursor-pointer">
                <img src={Back} alt="Edit Icon" className="" />
              </div>
              <span className="text-lg font-bold text-black ml-1">
                Promo Codes
              </span>
            </div>
          </Link>
        </div>
        <Card className="rounded-2xl bg-white xl:relative">
          <div className="border-solid border-inputFieldGrey rounded-sm p-2">
            <PromoCodeForm
              linkBack={() => navigate(`/main/promo-code`)}
              editPromoCode={editPromoCode}
              getPromoCodes={() => {}}
            />
          </div>
        </Card>
      </div>
    </div>
  );
};
export default EditPromoCode;
